import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Button, Spinner } from "react-bootstrap-v5";
import ReactPaginate from "react-paginate";
import ReactToPrint from "react-to-print";
import { toast } from "react-toastify";
import Select from "react-select";
import { reportService } from "../../Services/reportService";
import Loader from "../../Components/Loader";
const REACT_APP_API_BASEURL = process.env.REACT_APP_API_BASEURL;
let param = {};

const QBStatusOption = [
  { value: "", label: "All" },
  { value: false, label: "BOOKED" },
  { value: true, label: "NOT BOOKED" },
];

const pyStatusOption = [
  { value: "", label: "All" },
  { value: "fullypaid", label: "FULLY PAID" },
  { value: "partpaid", label: "PART PAID" },
  { value: "unpaid", label: "UNPAID" },
];

export const InvoiceReport = () => {
  const [reportlist, setReportlist] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStarDate] = useState();
  const [endDate, setEndData] = useState();
  const [qbStatus, setQbStatus] = useState("");
  const [pystatus, setPYStatus] = useState("");
  const [searchField, setSearchField] = useState();
  

  const componentRef = useRef();

  const getInvoiceReport = () => {
    setLoader(true);
    let param = {};
    param = { ...param, page: currentPage, limit: pagination.limit };

    if (startDate && endDate) {
      param["startDate"] = getTimeStamp(startDate);
      param["endDate"] = getTimeStamp(endDate);
    }
    if (qbStatus !== "") {
      param["draft"] = qbStatus;
    }
    if (pystatus !== "") {
      param["status"] = pystatus;
    }
    if (searchField) {
      param["search"] = searchField;
    }

    reportService
      .getInvoiceReport(param)
      .then((res) => {
        setReportlist(res.data);
        setLoader(false);
        setPagination({ ...pagination, ...res.pagination });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getTimeStamp = (date) => {
    let SingleTimestamp = new Date(date);
    return SingleTimestamp.getTime();
  };

  const onPageChangeEvent = (e) => {
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  const exportToExcel = () => {
    const params = startDate
      ? { startDate: startDate, endDate: endDate }
      : null;
    reportService.invoiceReportexcel(params).then((result) => {
      if (result.status === true) {
        window.location.href = `${REACT_APP_API_BASEURL}/${result.data}`;
      } else {
        toast.error("Something went wrong");
      }
    });
  };

  // reportlist.map((item, index)=>{
  //   console.log(item?.invoices, "iiiiiiiiiiiiiiiiiii")
  // })

  useEffect(() => {
    getInvoiceReport();
  }, [currentPage, endDate, qbStatus, pystatus, searchField]);

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="row mb-3">
            <div className="col-2">
                <label>Search Token</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search.."
                  onChange={(e) => setSearchField(e.target.value)}
                  value={searchField}
                />
              </div>
            <div className="col-sm-2">
                <label>QB Status</label>
                <Select
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      height: "34px", // Fixed height
                      minHeight: "34px",
                      display: "flex",
                      alignItems: "center", // Centers content vertically
                      boxShadow: "0 0 0 0px #f46a6a",
                    }),
                    valueContainer: (provided) => ({
                      ...provided,
                      height: "34px", // Match control height
                      display: "flex",
                      alignItems: "center", // Center text vertically
                      padding: "0px 8px",
                    }),
                    indicatorsContainer: (provided) => ({
                      ...provided,
                      height: "34px", // Align dropdown indicators
                      display: "flex",
                      alignItems: "center",
                    }),
                  }}
                  onChange={(e) => setQbStatus(e.value)}
                  placeholder="QB Status"
                  options={QBStatusOption}
                />
              </div>
              <div className="col-md-2">
                <label>Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) => setStarDate(e.target.value)}
                  value={startDate}
                />
              </div>
              <div className="col-md-2">
                <label>End Date</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) => setEndData(e.target.value)}
                  value={endDate}
                />
              </div>
              <div className="col-sm-2">
                <label>Payment Status</label>
                <Select
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      height: "34px", // Fixed height
                      minHeight: "34px",
                      display: "flex",
                      alignItems: "center", // Centers content vertically
                      boxShadow: "0 0 0 0px #f46a6a",
                    }),
                    valueContainer: (provided) => ({
                      ...provided,
                      height: "34px", // Match control height
                      display: "flex",
                      alignItems: "center", // Center text vertically
                      padding: "0px 8px",
                    }),
                    indicatorsContainer: (provided) => ({
                      ...provided,
                      height: "34px", // Align dropdown indicators
                      display: "flex",
                      alignItems: "center",
                    }),
                  }}
                  onChange={(e) => setPYStatus(e.value)}
                  placeholder="Payment Status"
                  options={pyStatusOption}
                />
              </div>
              <div className="col-md-2 d-flex justify-content-end mt-3">
                <Button
                  className="me-2 ps-4 pe-4"
                  variant="success"
                  style={{height: "40px"}}
                  onClick={exportToExcel}
                >
                  {" "}
                  Excel{" "}
                </Button>
                <ReactToPrint
                  trigger={() => {
                    return (
                      <Button variant="secondary" className="ps-4 pe-4" style={{height: "40px"}}>
                        Print
                      </Button>
                    );
                  }}
                  content={() => componentRef.current}
                  bodyClass={"printElement m-5"}
                />
              </div>
            </div>
            <div className="table-responsive" ref={componentRef}>
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>S no.</th>
                    <th>Job Number</th>
                    <th>Date</th>
                    <th>Invoice Date</th>
                    <th>
                      Invoice Amount
                      <br />
                      (Without Vat)
                    </th>
                    <th>
                      Invoice Amount
                      <br />
                      (With Vat)
                    </th>
                    <th>Customer Name</th>
                    <th>Origin</th>
                    <th>Destination</th>
                  </tr>
                </thead>
                <tbody>
                  {reportlist &&
                    reportlist.length > 0 &&
                    reportlist.map((item, key) => (
                      <tr key={key} 
                      className={item?.invoices?.draft ? "custom-tr-drft" : "custom-tr-book"}
                      >
                        <td className="text-body fw-bold">
                          {(pagination.page - 1) * pagination.limit + (key + 1)}
                        </td>
                        {/* <td className="text-body fw-bold">
                          {(pagination.page - 1) * pagination.limit + (key + 1)}
                        </td> */}
                        <td>{item?.job_token}</td>
                        <td>
                          {item?.created_at
                            ? moment(item?.created_at).format("DD-MM-YYYY")
                            : "-"}
                        </td>
                        <td>
                          {item?.invoices?.created_date
                            ? moment(item?.invoices?.created_date).format(
                                "DD-MM-YYYY"
                              )
                            : "-"}
                        </td>
                        <td
                          style={{
                            whiteSpace: "normal",
                          }}
                        >
                          {item?.invoices?.lc_amount || "0"}
                        </td>
                        <td
                          style={{
                            whiteSpace: "normal",
                          }}
                        >
                          {item?.invoices?.gross_amount || "0"}
                        </td>
                        <td>{item?.customer_details?.name || "-"}</td>
                        <td>
                          {item?.shipment_details?.origin
                            ? item.shipment_details?.origin
                            : "-" || item?.shipment_details?.origin_country
                            ? item.shipment_details?.origin_country
                            : ""}
                        </td>
                        <td>
                          {item?.shipment_details?.destination
                            ? item.shipment_details?.destination
                            : "-" || item?.shipment_details?.destination_country
                            ? item.shipment_details?.destination_country
                            : ""}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              {/* <div className="text-center">
                {(loader && <Spinner animation="grow" size="sm" />) || ""}
              </div> */}
              {reportlist?.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}

              {reportlist &&
                reportlist.length > 0 &&
                pagination.totalRecord > pagination.limit && (
                  <ReactPaginate
                    previousLabel={
                      <img
                        src="assets/images/prev.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    forcePage={currentPage - 1}
                    nextLabel={
                      <img
                        src="assets/images/next.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={Math.ceil(
                      pagination.totalRecord / pagination.limit
                    )}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={(e) => onPageChangeEvent(e)}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                )}
            </div>
            <Loader isShow={loader} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceReport;
